// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsContainer_container__2S-J9","images":"SettingsContainer_images__P6rMz","button":"SettingsContainer_button__3Hnsv"};